<form class="select-serial-number" [formGroup]="form">

    <mat-radio-button class="mb-2 radio-button-new" [checked]="!isThirdParty"
        (change)="onChangeReceiverType()">{{'REQUEST.WITHDRAWAL.DEPOSIT_TO_MY_ACCOUNT' | translate }}</mat-radio-button>

    <div class="tc-form-field field-account-number size-md">
        <label class="label">
            {{'REQUEST.WITHDRAWAL.SELECT_ACCOUNT' | translate}}
        </label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field has-select-option">
            <mat-select formControlName="userAccountNumber" panelClass="panel-select-option-new"
                (selectionChange)="onSelectedUserAccountChange()">
                <mat-option [value]="userServiceAccount.id" *ngFor="let userServiceAccount of userServiceAccounts">
                    {{ userServiceAccount.title }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <mat-radio-button class="mb-2 radio-button-new" *ngIf="canSendThirdParty" [checked]="isThirdParty"
        (change)="onChangeReceiverType()">{{'REQUEST.WITHDRAWAL.DEPOSIT_TO_THIRD_PARTY_ACCOUNT' | translate
        }}</mat-radio-button>

    <div class="tc-form-field size-md" *ngIf="!isCryptoPage && canSendThirdParty">
        <label class="label">
            {{'REQUEST.WITHDRAWAL.ACCOUNT_INFORMATION' | translate}}
            <span class="required">*</span>
        </label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field has-textarea">
            <textarea matInput formControlName="recieverAccountNumber"
                placeholder="{{'REQUEST.WITHDRAWAL.ACCOUNT_INFORMATION' | translate}}" required></textarea>
            <mat-error class="error-text" *ngIf="f.recieverAccountNumber.hasError('walletAddressValidator')"
                [translate]="'VALIDATION.INVALID_FIELD'"
                [translateParams]="{name: ('REQUEST.WITHDRAWAL.ACCOUNT_INFORMATION' | translate)}">
            </mat-error>
        </mat-form-field>
    </div>

    <ng-container *ngIf="isCryptoPage">
        <!--Wallet Address-->
        <div class="tc-form-field size-md">
            <label class="label">
                {{'REQUEST.PAYMENT.WALLET_ADDRESS' | translate }}
                <span class="required">*</span>
            </label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field">
                <input matInput formControlName="recieverAccountNumber"
                    placeholder="{{'REQUEST.PAYMENT.WALLET_ADDRESS' | translate }}" required />
                <mat-error class="error-text" *ngIf="f.recieverAccountNumber.hasError('walletAddressValidator')"
                    [translate]="'VALIDATION.INVALID_FIELD'"
                    [translateParams]="{name: ('REQUEST.PAYMENT.WALLET_ADDRESS' | translate)}">
                </mat-error>
            </mat-form-field>
        </div>

        <!--Tag-->
        <div *ngIf="additionalDataType === additionalDataTypes.Tag" class="tc-form-field size-md">
            <label class="label">
                {{'REQUEST.PAYMENT.TAG' | translate}}
            </label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field">
                <input matInput formControlName="addtionalData" placeholder="{{'REQUEST.PAYMENT.TAG'| translate}}" />
            </mat-form-field>
        </div>

        <!--Memo-->
        <div class="tc-form-field size-md" *ngIf="additionalDataType === additionalDataTypes.MEMO">
            <label class="label">
                {{'REQUEST.PAYMENT.MEMO' | translate }}
            </label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field">
                <input matInput formControlName="addtionalData" placeholder="{{'REQUEST.PAYMENT.MEMO' | translate }}" />
            </mat-form-field>
        </div>
    </ng-container>




</form>